module.exports = __webpack_public_path__ + "static/media/i77a.425e7c2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i77a.svg
// module id = 205
// module chunks = 12